import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M10.764 6.647H6.646c-.91 0-1.648.737-1.648 1.647v9.059c0 .91.738 1.647 1.648 1.647h9.06c.91 0 1.648-.737 1.648-1.647v-4.118M16.19 5.482a1.648 1.648 0 0 1 2.33 2.33l-7.072 7.07h-2.33v-2.329l7.072-7.07Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render };